// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import store from './store'
import {i18n} from './i18n'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '../theme/index.css'
import App from './App'
import router from './router'
import { newClient } from './api/axios-client-factory'
import VueClipboard from 'vue-clipboard2';
import { apiToken, apiCommon } from './utils/common';
import { tokenLoginAjax } from './api/login/login';
//import Axios from 'axios'
//导入需要全局暴露的过滤器
import filters from "./utils/filters";

Vue.use(ElementUI,{
  i18n:(key,value)=>i18n.t(key,value)
})
Vue.use(Vant);


//全局注册过滤器
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(ElementUI);
Vue.prototype.newClient=newClient;


//设置语言
store.commit("setLanguage");
// 只能输入数字
Vue.prototype.$num=(value)=>{
  return value.replace(/\D/g,'')
}
// 禁止输入数字
Vue.prototype.$notNum=(value)=>{
  return value.replace(/\d/g,'')
}

//Axios.defaults.baseURL = global_huanjing.apiUrl;
// 路由守卫
let tokenLoginFlag = false; // 防止路由守卫重复触发token登录
router.beforeEach(async (to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }

  const common = apiCommon();
  const tk = apiToken();
  const cachedAppToken = localStorage.getItem('appToken');
  const currentAppToken = tk && typeof tk === 'string' && tk.trim() !== '' ? tk.trim() : '';
  if (common && typeof common === 'string' && common.trim() !== '') {
    if (currentAppToken) {
      // 两个都有值且有 token：对比缓存的 appToken，相同则不做操作，不同则清空后重新登录
      if (cachedAppToken && cachedAppToken !== currentAppToken) {
        localStorage.removeItem('appToken');
        store.commit('loginOut')
      }
    } else {
      if(cachedAppToken){
        // 有 common 但无 token并且有cachedAppToken，清空登录状态
        localStorage.removeItem('appToken');
        store.commit('loginOut')
      }
    }
  }
  console.log('cachedAppToken>>>>>>>>>>>',cachedAppToken)
  console.log('tk>>>>>>>>>>>>>>>>',tk)

  
  console.log('tokenLoginFlag', tokenLoginFlag);
  // store中无userInfo，尝试通过apiToken进行静默token登录
  if (!tokenLoginFlag) {
    tokenLoginFlag = true;
    if (tk && typeof tk === 'string' && tk.trim() !== '') {
      try {
        console.log('tokenLoginAjax', tk, i18n.locale);
        const { data } = await tokenLoginAjax({ token: tk, lang: i18n.locale });
        console.log('data', data);
        if (data.data.state === 0) {
          store.commit('setUser', data.data);
          localStorage.setItem('appToken', tk);
          console.log('data.data', data.data);
          if (data.data.status === 3) {
            next('/guild/my-guild-detail')
          } else {
            next('/apply')
          }
          tokenLoginFlag = false;
          return
        }
      } catch (e) {
        // token登录失败，继续跳转登录页
      }
    }
    tokenLoginFlag = false;
  }
  console.log('---------------------------------------')

  const userInfo = store.state.userInfo;
  const hasUserInfo = userInfo && userInfo.token !== null && typeof userInfo.token !== 'undefined' && userInfo.token.toString().trim() !== '';
  console.log('userInfo>>>>>>>>>>>>>>>>>>>>>>>',userInfo)
  if (hasUserInfo) {
    const status = store.state.userInfo.status;
    console.log('status>>>>>>>>>>>>>>>>>>status', status)
    if (status === 3) {
      next()
    } else if (to.path === '/apply') {
      next()
    } else {
      next('/apply')
    }
    return
  }

  next({
    path: '/login',
    query: {
      code: 401,
      returnUrl: from.path
    }
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js